import angular from 'angular';
import components from './components';

export default angular.module('insuranceFireAndGeneralModal.scenes', [
  components,
]).name;
